"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _NavDropdown = _interopRequireDefault(require("./NavDropdown"));

var _Button = _interopRequireDefault(require("../Buttons/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Nav = _styledComponents.default.nav.withConfig({
  displayName: "GlobalMenu__Nav",
  componentId: "design-system__sc-1f7peyt-0"
})(["box-sizing:border-box;display:flex;align-items:center;& > *{box-sizing:border-box;}& > * + *{margin-left:0.5rem;}& > ul{display:flex;align-items:stretch;list-style:none;margin:0;padding:0;}& > ul > a{align-self:center;}"]);

const GlobalMenu = _ref => {
  let {
    menu,
    action,
    icon
  } = _ref;

  if (menu.length === 0) {
    return /*#__PURE__*/_react.default.createElement(Nav, {
      role: "navigation"
    });
  }

  return /*#__PURE__*/_react.default.createElement(Nav, {
    role: "navigation"
  }, /*#__PURE__*/_react.default.createElement("ul", null, [...menu].map(menuItem => /*#__PURE__*/_react.default.createElement(_NavDropdown.default, {
    title: menuItem.title,
    pages: menuItem.pages,
    key: menuItem.title,
    icon: icon
  }))), action && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "contained",
    profile: "primary",
    url: action.url
  }, action.title));
};

GlobalMenu.propTypes = {
  menu: _propTypes.default.arrayOf(_propTypes.default.object),
  icon: _propTypes.default.string,
  action: _propTypes.default.shape({
    url: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired
  })
};
GlobalMenu.defaultProps = {
  menu: [],
  icon: undefined,
  action: undefined
};
var _default = GlobalMenu;
exports.default = _default;